import styled from 'styled-components';

export const ContentWrapper = styled.div`
  background: ${({ theme }): string => theme.admanColors!.gray.light.fg[6]};
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: start;
`;

export const Content = styled.div`
  margin-top: ${({ theme }): string => theme.spacers!.spacer12};
  padding: ${({ theme }): string => theme.spacers!.spacer05};
  border-radius: 8px;
  background: ${({ theme }): string => theme.colors!.colorWhite};
  box-shadow: 0 0 4px -1px rgb(23 29 35 / 25%);
`;
